@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(-1_512_440_710)
internal val Res.string.premade_copy_sheet: StringResource by lazy {
      StringResource("string:premade_copy_sheet", "premade_copy_sheet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25464, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23212, 74),
      ))
    }

@delegate:ResourceContentHash(1_722_587_827)
internal val Res.string.premade_copy_sheet_action: StringResource by lazy {
      StringResource("string:premade_copy_sheet_action", "premade_copy_sheet_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25349, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23105, 41),
      ))
    }

@delegate:ResourceContentHash(787_306_144)
internal val Res.string.premade_copy_sheet_title: StringResource by lazy {
      StringResource("string:premade_copy_sheet_title", "premade_copy_sheet_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25391, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23147, 64),
      ))
    }

@delegate:ResourceContentHash(-674_559_490)
internal val Res.string.premade_delete_item: StringResource by lazy {
      StringResource("string:premade_delete_item", "premade_delete_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25551, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23287, 43),
      ))
    }

@delegate:ResourceContentHash(-1_005_225_676)
internal val Res.string.premade_edit_item: StringResource by lazy {
      StringResource("string:premade_edit_item", "premade_edit_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25603, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23331, 37),
      ))
    }

@delegate:ResourceContentHash(-472_990_759)
internal val Res.string.premade_go_to_page: StringResource by lazy {
      StringResource("string:premade_go_to_page", "premade_go_to_page", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25653, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23369, 54),
      ))
    }

@delegate:ResourceContentHash(650_180_510)
internal val Res.string.premade_import_from_chest: StringResource by lazy {
      StringResource("string:premade_import_from_chest", "premade_import_from_chest", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25792, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23492, 57),
      ))
    }

@delegate:ResourceContentHash(-1_176_668_668)
internal val Res.string.premade_import_from_chest_title: StringResource by lazy {
      StringResource("string:premade_import_from_chest_title", "premade_import_from_chest_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25712, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23424, 67),
      ))
    }

@delegate:ResourceContentHash(402_460_174)
internal val Res.string.premade_import_items: StringResource by lazy {
      StringResource("string:premade_import_items", "premade_import_items", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25850, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23550, 36),
      ))
    }

@delegate:ResourceContentHash(2_121_048_316)
internal val Res.string.premade_inventory_section: StringResource by lazy {
      StringResource("string:premade_inventory_section", "premade_inventory_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25891, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23587, 57),
      ))
    }

@delegate:ResourceContentHash(-19_764_542)
internal val Res.string.premade_pass: StringResource by lazy {
      StringResource("string:premade_pass", "premade_pass", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25953, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23645, 28),
      ))
    }

@delegate:ResourceContentHash(589_978_570)
internal val Res.string.premade_view_carousel: StringResource by lazy {
      StringResource("string:premade_view_carousel", "premade_view_carousel", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25982, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23674, 41),
      ))
    }

@delegate:ResourceContentHash(-1_819_053_266)
internal val Res.string.premade_view_grid: StringResource by lazy {
      StringResource("string:premade_view_grid", "premade_view_grid", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26024, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23716, 33),
      ))
    }

@delegate:ResourceContentHash(-340_781_345)
internal val Res.string.remove_image: StringResource by lazy {
      StringResource("string:remove_image", "remove_image", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26058, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23750, 36),
      ))
    }

@delegate:ResourceContentHash(109_009_299)
internal val Res.string.remove_player: StringResource by lazy {
      StringResource("string:remove_player", "remove_player", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26103, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23787, 41),
      ))
    }

@delegate:ResourceContentHash(-1_016_688_836)
internal val Res.string.restore_announcement: StringResource by lazy {
      StringResource("string:restore_announcement", "restore_announcement", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26149, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23829, 56),
      ))
    }

@delegate:ResourceContentHash(-635_758_621)
internal val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26206, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23886, 21),
      ))
    }

@delegate:ResourceContentHash(621_985_171)
internal val Res.string.roll: StringResource by lazy {
      StringResource("string:roll", "roll", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26236, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23908, 20),
      ))
    }

@delegate:ResourceContentHash(1_994_826_245)
internal val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26257, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23929, 20),
      ))
    }

@delegate:ResourceContentHash(52_578_532)
internal val Res.string.search_sounds: StringResource by lazy {
      StringResource("string:search_sounds", "search_sounds", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26286, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23950, 29),
      ))
    }

@delegate:ResourceContentHash(1_135_518_178)
internal val Res.string.security_alert: StringResource by lazy {
      StringResource("string:security_alert", "security_alert", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26324, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23980, 38),
      ))
    }

@delegate:ResourceContentHash(1_242_383_913)
internal val Res.string.select: StringResource by lazy {
      StringResource("string:select", "select", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26849, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24405, 22),
      ))
    }

@delegate:ResourceContentHash(288_916_723)
internal val Res.string.select_audio_file: StringResource by lazy {
      StringResource("string:select_audio_file", "select_audio_file", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26375, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24019, 49),
      ))
    }

@delegate:ResourceContentHash(-1_899_919_094)
internal val Res.string.select_character: StringResource by lazy {
      StringResource("string:select_character", "select_character", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26600, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24200, 48),
      ))
    }

@delegate:ResourceContentHash(807_294_165)
internal val Res.string.select_character_for_table: StringResource by lazy {
      StringResource("string:select_character_for_table", "select_character_for_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26441, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24069, 62),
      ))
    }

@delegate:ResourceContentHash(-186_223_046)
internal val Res.string.select_character_prompt: StringResource by lazy {
      StringResource("string:select_character_prompt", "select_character_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26516, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24132, 67),
      ))
    }

@delegate:ResourceContentHash(444_364_408)
internal val Res.string.select_image: StringResource by lazy {
      StringResource("string:select_image", "select_image", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26661, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24249, 36),
      ))
    }

@delegate:ResourceContentHash(-218_664_861)
internal val Res.string.select_universe: StringResource by lazy {
      StringResource("string:select_universe", "select_universe", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26793, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24353, 51),
      ))
    }

@delegate:ResourceContentHash(-1_994_168_444)
internal val Res.string.select_universe_prompt: StringResource by lazy {
      StringResource("string:select_universe_prompt", "select_universe_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26714, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24286, 66),
      ))
    }

@delegate:ResourceContentHash(2_084_366_988)
internal val Res.string.send: StringResource by lazy {
      StringResource("string:send", "send", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26884, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24428, 20),
      ))
    }

@delegate:ResourceContentHash(-241_746_045)
internal val Res.string.shake_roll_tap_to_close: StringResource by lazy {
      StringResource("string:shake_roll_tap_to_close", "shake_roll_tap_to_close", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26909, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24449, 59),
      ))
    }

@delegate:ResourceContentHash(1_472_950_516)
internal val Res.string.shake_roll_title: StringResource by lazy {
      StringResource("string:shake_roll_title", "shake_roll_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26985, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24509, 40),
      ))
    }

@delegate:ResourceContentHash(-1_332_902_912)
internal val Res.string.shake_to_roll_hint: StringResource by lazy {
      StringResource("string:shake_to_roll_hint", "shake_to_roll_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27030, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24550, 82),
      ))
    }

@delegate:ResourceContentHash(-452_569_019)
internal val Res.string.show_announcement_text: StringResource by lazy {
      StringResource("string:show_announcement_text", "show_announcement_text", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27133, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24633, 42),
      ))
    }

@delegate:ResourceContentHash(-1_446_474_564)
internal val Res.string.sign_in_anonymous: StringResource by lazy {
      StringResource("string:sign_in_anonymous", "sign_in_anonymous", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27188, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24676, 49),
      ))
    }

@delegate:ResourceContentHash(567_129_763)
internal val Res.string.sign_in_with_apple: StringResource by lazy {
      StringResource("string:sign_in_with_apple", "sign_in_with_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27254, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24726, 50),
      ))
    }

@delegate:ResourceContentHash(-1_086_212_094)
internal val Res.string.sign_in_with_google: StringResource by lazy {
      StringResource("string:sign_in_with_google", "sign_in_with_google", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27309, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24777, 55),
      ))
    }

@delegate:ResourceContentHash(-665_393_384)
internal val Res.string.sign_in_with_otp: StringResource by lazy {
      StringResource("string:sign_in_with_otp", "sign_in_with_otp", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27365, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24833, 48),
      ))
    }

@delegate:ResourceContentHash(-1_785_964_969)
internal val Res.string.sign_out: StringResource by lazy {
      StringResource("string:sign_out", "sign_out", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27418, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24882, 28),
      ))
    }

@delegate:ResourceContentHash(-1_444_723_401)
internal val Res.string.sound_name: StringResource by lazy {
      StringResource("string:sound_name", "sound_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27507, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24959, 34),
      ))
    }

@delegate:ResourceContentHash(1_681_872_319)
internal val Res.string.sound_name_hint: StringResource by lazy {
      StringResource("string:sound_name_hint", "sound_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27455, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24911, 47),
      ))
    }

@delegate:ResourceContentHash(-1_067_025_388)
internal val Res.string.sound_shuffle: StringResource by lazy {
      StringResource("string:sound_shuffle", "sound_shuffle", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27542, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24994, 33),
      ))
    }

@delegate:ResourceContentHash(-81_914_934)
internal val Res.string.sound_stop_playback: StringResource by lazy {
      StringResource("string:sound_stop_playback", "sound_stop_playback", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27588, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25028, 47),
      ))
    }

@delegate:ResourceContentHash(-437_011_040)
internal val Res.string.sound_tags: StringResource by lazy {
      StringResource("string:sound_tags", "sound_tags", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27644, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25076, 26),
      ))
    }

@delegate:ResourceContentHash(-1_049_099_807)
internal val Res.string.sound_type: StringResource by lazy {
      StringResource("string:sound_type", "sound_type", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27903, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25287, 34),
      ))
    }

@delegate:ResourceContentHash(1_347_046_850)
internal val Res.string.sound_type_info: StringResource by lazy {
      StringResource("string:sound_type_info", "sound_type_info", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27671, 231),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25103, 183),
      ))
    }

@delegate:ResourceContentHash(1_853_571_040)
internal val Res.string.sound_volume: StringResource by lazy {
      StringResource("string:sound_volume", "sound_volume", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27938, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25322, 28),
      ))
    }

@delegate:ResourceContentHash(1_344_819_259)
internal val Res.string.sounds: StringResource by lazy {
      StringResource("string:sounds", "sounds", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27967, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25351, 22),
      ))
    }

@delegate:ResourceContentHash(-587_180_000)
internal val Res.string.table: StringResource by lazy {
      StringResource("string:table", "table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28165, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25537, 21),
      ))
    }

@delegate:ResourceContentHash(-1_712_533_093)
internal val Res.string.table_code: StringResource by lazy {
      StringResource("string:table_code", "table_code", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27990, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25374, 34),
      ))
    }

@delegate:ResourceContentHash(-1_842_294_570)
internal val Res.string.table_created: StringResource by lazy {
      StringResource("string:table_created", "table_created", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28029, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25409, 33),
      ))
    }

@delegate:ResourceContentHash(-80_274_158)
internal val Res.string.table_name: StringResource by lazy {
      StringResource("string:table_name", "table_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28126, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25502, 34),
      ))
    }

@delegate:ResourceContentHash(357_085_213)
internal val Res.string.table_name_placeholder: StringResource by lazy {
      StringResource("string:table_name_placeholder", "table_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28067, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25443, 58),
      ))
    }

@delegate:ResourceContentHash(630_033_394)
internal val Res.string.tag_calm: StringResource by lazy {
      StringResource("string:tag_calm", "tag_calm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28187, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25559, 24),
      ))
    }

@delegate:ResourceContentHash(1_626_849_088)
internal val Res.string.tag_combat: StringResource by lazy {
      StringResource("string:tag_combat", "tag_combat", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28212, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25584, 26),
      ))
    }

@delegate:ResourceContentHash(-1_572_655_680)
internal val Res.string.tag_tension: StringResource by lazy {
      StringResource("string:tag_tension", "tag_tension", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28239, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25611, 31),
      ))
    }

@delegate:ResourceContentHash(241_326_191)
internal val Res.string.tap_to_change_music: StringResource by lazy {
      StringResource("string:tap_to_change_music", "tap_to_change_music", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28271, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25643, 55),
      ))
    }

@delegate:ResourceContentHash(2_065_971_540)
internal val Res.string.terms_accept_button: StringResource by lazy {
      StringResource("string:terms_accept_button", "terms_accept_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28343, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25699, 39),
      ))
    }

@delegate:ResourceContentHash(-2_126_493_304)
internal val Res.string.terms_accept_checkbox: StringResource by lazy {
      StringResource("string:terms_accept_checkbox", "terms_accept_checkbox", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28383, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25739, 73),
      ))
    }

@delegate:ResourceContentHash(-349_761_693)
internal val Res.string.terms_content: StringResource by lazy {
      StringResource("string:terms_content", "terms_content", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28481, 13669),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25813, 11893),
      ))
    }

@delegate:ResourceContentHash(1_656_699_401)
internal val Res.string.terms_decline_button: StringResource by lazy {
      StringResource("string:terms_decline_button", "terms_decline_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42151, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37707, 40),
      ))
    }

@delegate:ResourceContentHash(628_125_107)
internal val Res.string.terms_title: StringResource by lazy {
      StringResource("string:terms_title", "terms_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42192, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37748, 47),
      ))
    }

@delegate:ResourceContentHash(-1_859_975_456)
internal val Res.string.timer_active_timers: StringResource by lazy {
      StringResource("string:timer_active_timers", "timer_active_timers", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42260, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37796, 47),
      ))
    }

@delegate:ResourceContentHash(1_925_376_640)
internal val Res.string.timer_duration_hint: StringResource by lazy {
      StringResource("string:timer_duration_hint", "timer_duration_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42312, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37844, 39),
      ))
    }

@delegate:ResourceContentHash(-1_431_749_641)
internal val Res.string.timer_duration_label: StringResource by lazy {
      StringResource("string:timer_duration_label", "timer_duration_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42352, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37884, 40),
      ))
    }

@delegate:ResourceContentHash(120_496_849)
internal val Res.string.timer_expired: StringResource by lazy {
      StringResource("string:timer_expired", "timer_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42389, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37925, 33),
      ))
    }

@delegate:ResourceContentHash(1_692_763_880)
internal val Res.string.timer_gm_continue_after_end: StringResource by lazy {
      StringResource("string:timer_gm_continue_after_end", "timer_gm_continue_after_end", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42423, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37959, 59),
      ))
    }

@delegate:ResourceContentHash(1_355_827_277)
internal val Res.string.timer_gm_launch_title: StringResource by lazy {
      StringResource("string:timer_gm_launch_title", "timer_gm_launch_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42491, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38019, 49),
      ))
    }

@delegate:ResourceContentHash(-174_957_236)
internal val Res.string.timer_launch: StringResource by lazy {
      StringResource("string:timer_launch", "timer_launch", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42600, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38112, 28),
      ))
    }

@delegate:ResourceContentHash(-1_683_811_747)
internal val Res.string.timer_launch_title: StringResource by lazy {
      StringResource("string:timer_launch_title", "timer_launch_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42549, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38069, 42),
      ))
    }

@delegate:ResourceContentHash(2_117_789_312)
internal val Res.string.timer_pause: StringResource by lazy {
      StringResource("string:timer_pause", "timer_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42629, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38141, 27),
      ))
    }

@delegate:ResourceContentHash(-872_799_752)
internal val Res.string.timer_resume: StringResource by lazy {
      StringResource("string:timer_resume", "timer_resume", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42657, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38169, 28),
      ))
    }

@delegate:ResourceContentHash(-2_002_588_711)
internal val Res.string.timer_stop: StringResource by lazy {
      StringResource("string:timer_stop", "timer_stop", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42690, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38198, 26),
      ))
    }

@delegate:ResourceContentHash(-462_061_475)
internal val Res.string.timer_targeted_players: StringResource by lazy {
      StringResource("string:timer_targeted_players", "timer_targeted_players", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42721, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38225, 50),
      ))
    }

@delegate:ResourceContentHash(1_853_972_179)
internal val Res.string.tools: StringResource by lazy {
      StringResource("string:tools", "tools", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42772, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38276, 21),
      ))
    }

@delegate:ResourceContentHash(281_405_420)
internal val Res.string.type_ambient: StringResource by lazy {
      StringResource("string:type_ambient", "type_ambient", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42794, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38298, 32),
      ))
    }

@delegate:ResourceContentHash(1_047_150_285)
internal val Res.string.type_effect: StringResource by lazy {
      StringResource("string:type_effect", "type_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42827, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38331, 31),
      ))
    }

@delegate:ResourceContentHash(-376_401_619)
internal val Res.string.type_music: StringResource by lazy {
      StringResource("string:type_music", "type_music", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42855, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38363, 26),
      ))
    }

@delegate:ResourceContentHash(1_820_666_552)
internal val Res.string.universe_character_section: StringResource by lazy {
      StringResource("string:universe_character_section", "universe_character_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42886, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38390, 70),
      ))
    }

@delegate:ResourceContentHash(-436_393)
internal val Res.string.universe_custom_fallback: StringResource by lazy {
      StringResource("string:universe_custom_fallback", "universe_custom_fallback", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 42965, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38461, 52),
      ))
    }

@delegate:ResourceContentHash(1_601_075_120)
internal val Res.string.universe_dice_advanced: StringResource by lazy {
      StringResource("string:universe_dice_advanced", "universe_dice_advanced", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43026, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38514, 54),
      ))
    }

@delegate:ResourceContentHash(-706_980_976)
internal val Res.string.universe_dice_critical_failure: StringResource by lazy {
      StringResource("string:universe_dice_critical_failure", "universe_dice_critical_failure", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43081, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38569, 50),
      ))
    }

@delegate:ResourceContentHash(515_021_825)
internal val Res.string.universe_dice_critical_hint: StringResource by lazy {
      StringResource("string:universe_dice_critical_hint", "universe_dice_critical_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43128, 219),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38620, 167),
      ))
    }

@delegate:ResourceContentHash(1_461_804_643)
internal val Res.string.universe_dice_critical_section: StringResource by lazy {
      StringResource("string:universe_dice_critical_section", "universe_dice_critical_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43348, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38788, 58),
      ))
    }

@delegate:ResourceContentHash(-982_532_685)
internal val Res.string.universe_dice_critical_success: StringResource by lazy {
      StringResource("string:universe_dice_critical_success", "universe_dice_critical_success", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43411, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38847, 50),
      ))
    }

@delegate:ResourceContentHash(1_450_616_037)
internal val Res.string.universe_dice_default: StringResource by lazy {
      StringResource("string:universe_dice_default", "universe_dice_default", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43534, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38958, 45),
      ))
    }

@delegate:ResourceContentHash(-354_141_427)
internal val Res.string.universe_dice_default_count: StringResource by lazy {
      StringResource("string:universe_dice_default_count", "universe_dice_default_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43462, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38898, 59),
      ))
    }

@delegate:ResourceContentHash(-1_181_149_536)
internal val Res.string.universe_dice_face_style_label: StringResource by lazy {
      StringResource("string:universe_dice_face_style_label", "universe_dice_face_style_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43584, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39004, 54),
      ))
    }

@delegate:ResourceContentHash(433_002_682)
internal val Res.string.universe_dice_face_style_numerals: StringResource by lazy {
      StringResource("string:universe_dice_face_style_numerals", "universe_dice_face_style_numerals", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43643, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39059, 53),
      ))
    }

@delegate:ResourceContentHash(1_476_279_518)
internal val Res.string.universe_dice_face_style_skull: StringResource by lazy {
      StringResource("string:universe_dice_face_style_skull", "universe_dice_face_style_skull", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43697, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39113, 54),
      ))
    }

@delegate:ResourceContentHash(-629_561_874)
internal val Res.string.universe_dice_modifiers_enabled: StringResource by lazy {
      StringResource("string:universe_dice_modifiers_enabled", "universe_dice_modifiers_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43756, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39168, 67),
      ))
    }

@delegate:ResourceContentHash(1_898_781_856)
internal val Res.string.universe_dice_multi_enabled: StringResource by lazy {
      StringResource("string:universe_dice_multi_enabled", "universe_dice_multi_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43832, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39236, 67),
      ))
    }

@delegate:ResourceContentHash(-2_067_708_550)
internal val Res.string.universe_dice_section: StringResource by lazy {
      StringResource("string:universe_dice_section", "universe_dice_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44075, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39435, 37),
      ))
    }

@delegate:ResourceContentHash(592_496_474)
internal val Res.string.universe_dice_section_hint: StringResource by lazy {
      StringResource("string:universe_dice_section_hint", "universe_dice_section_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43908, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39304, 130),
      ))
    }

@delegate:ResourceContentHash(1_010_255_413)
internal val Res.string.universe_dice_total_enabled: StringResource by lazy {
      StringResource("string:universe_dice_total_enabled", "universe_dice_total_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44113, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39473, 63),
      ))
    }

@delegate:ResourceContentHash(1_925_011_821)
internal val Res.string.universe_dice_winning_high: StringResource by lazy {
      StringResource("string:universe_dice_winning_high", "universe_dice_winning_high", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44181, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39537, 54),
      ))
    }

@delegate:ResourceContentHash(1_858_459_220)
internal val Res.string.universe_dice_winning_label: StringResource by lazy {
      StringResource("string:universe_dice_winning_label", "universe_dice_winning_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44248, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39592, 55),
      ))
    }

@delegate:ResourceContentHash(-802_369_052)
internal val Res.string.universe_dice_winning_low: StringResource by lazy {
      StringResource("string:universe_dice_winning_low", "universe_dice_winning_low", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44304, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39648, 53),
      ))
    }

@delegate:ResourceContentHash(2_080_566_735)
internal val Res.string.universe_features_section: StringResource by lazy {
      StringResource("string:universe_features_section", "universe_features_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44370, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39702, 45),
      ))
    }

@delegate:ResourceContentHash(-121_264_114)
internal val Res.string.universe_list_loading: StringResource by lazy {
      StringResource("string:universe_list_loading", "universe_list_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44428, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39748, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("premade_copy_sheet", Res.string.premade_copy_sheet)
  map.put("premade_copy_sheet_action", Res.string.premade_copy_sheet_action)
  map.put("premade_copy_sheet_title", Res.string.premade_copy_sheet_title)
  map.put("premade_delete_item", Res.string.premade_delete_item)
  map.put("premade_edit_item", Res.string.premade_edit_item)
  map.put("premade_go_to_page", Res.string.premade_go_to_page)
  map.put("premade_import_from_chest", Res.string.premade_import_from_chest)
  map.put("premade_import_from_chest_title", Res.string.premade_import_from_chest_title)
  map.put("premade_import_items", Res.string.premade_import_items)
  map.put("premade_inventory_section", Res.string.premade_inventory_section)
  map.put("premade_pass", Res.string.premade_pass)
  map.put("premade_view_carousel", Res.string.premade_view_carousel)
  map.put("premade_view_grid", Res.string.premade_view_grid)
  map.put("remove_image", Res.string.remove_image)
  map.put("remove_player", Res.string.remove_player)
  map.put("restore_announcement", Res.string.restore_announcement)
  map.put("retry", Res.string.retry)
  map.put("roll", Res.string.roll)
  map.put("save", Res.string.save)
  map.put("search_sounds", Res.string.search_sounds)
  map.put("security_alert", Res.string.security_alert)
  map.put("select", Res.string.select)
  map.put("select_audio_file", Res.string.select_audio_file)
  map.put("select_character", Res.string.select_character)
  map.put("select_character_for_table", Res.string.select_character_for_table)
  map.put("select_character_prompt", Res.string.select_character_prompt)
  map.put("select_image", Res.string.select_image)
  map.put("select_universe", Res.string.select_universe)
  map.put("select_universe_prompt", Res.string.select_universe_prompt)
  map.put("send", Res.string.send)
  map.put("shake_roll_tap_to_close", Res.string.shake_roll_tap_to_close)
  map.put("shake_roll_title", Res.string.shake_roll_title)
  map.put("shake_to_roll_hint", Res.string.shake_to_roll_hint)
  map.put("show_announcement_text", Res.string.show_announcement_text)
  map.put("sign_in_anonymous", Res.string.sign_in_anonymous)
  map.put("sign_in_with_apple", Res.string.sign_in_with_apple)
  map.put("sign_in_with_google", Res.string.sign_in_with_google)
  map.put("sign_in_with_otp", Res.string.sign_in_with_otp)
  map.put("sign_out", Res.string.sign_out)
  map.put("sound_name", Res.string.sound_name)
  map.put("sound_name_hint", Res.string.sound_name_hint)
  map.put("sound_shuffle", Res.string.sound_shuffle)
  map.put("sound_stop_playback", Res.string.sound_stop_playback)
  map.put("sound_tags", Res.string.sound_tags)
  map.put("sound_type", Res.string.sound_type)
  map.put("sound_type_info", Res.string.sound_type_info)
  map.put("sound_volume", Res.string.sound_volume)
  map.put("sounds", Res.string.sounds)
  map.put("table", Res.string.table)
  map.put("table_code", Res.string.table_code)
  map.put("table_created", Res.string.table_created)
  map.put("table_name", Res.string.table_name)
  map.put("table_name_placeholder", Res.string.table_name_placeholder)
  map.put("tag_calm", Res.string.tag_calm)
  map.put("tag_combat", Res.string.tag_combat)
  map.put("tag_tension", Res.string.tag_tension)
  map.put("tap_to_change_music", Res.string.tap_to_change_music)
  map.put("terms_accept_button", Res.string.terms_accept_button)
  map.put("terms_accept_checkbox", Res.string.terms_accept_checkbox)
  map.put("terms_content", Res.string.terms_content)
  map.put("terms_decline_button", Res.string.terms_decline_button)
  map.put("terms_title", Res.string.terms_title)
  map.put("timer_active_timers", Res.string.timer_active_timers)
  map.put("timer_duration_hint", Res.string.timer_duration_hint)
  map.put("timer_duration_label", Res.string.timer_duration_label)
  map.put("timer_expired", Res.string.timer_expired)
  map.put("timer_gm_continue_after_end", Res.string.timer_gm_continue_after_end)
  map.put("timer_gm_launch_title", Res.string.timer_gm_launch_title)
  map.put("timer_launch", Res.string.timer_launch)
  map.put("timer_launch_title", Res.string.timer_launch_title)
  map.put("timer_pause", Res.string.timer_pause)
  map.put("timer_resume", Res.string.timer_resume)
  map.put("timer_stop", Res.string.timer_stop)
  map.put("timer_targeted_players", Res.string.timer_targeted_players)
  map.put("tools", Res.string.tools)
  map.put("type_ambient", Res.string.type_ambient)
  map.put("type_effect", Res.string.type_effect)
  map.put("type_music", Res.string.type_music)
  map.put("universe_character_section", Res.string.universe_character_section)
  map.put("universe_custom_fallback", Res.string.universe_custom_fallback)
  map.put("universe_dice_advanced", Res.string.universe_dice_advanced)
  map.put("universe_dice_critical_failure", Res.string.universe_dice_critical_failure)
  map.put("universe_dice_critical_hint", Res.string.universe_dice_critical_hint)
  map.put("universe_dice_critical_section", Res.string.universe_dice_critical_section)
  map.put("universe_dice_critical_success", Res.string.universe_dice_critical_success)
  map.put("universe_dice_default", Res.string.universe_dice_default)
  map.put("universe_dice_default_count", Res.string.universe_dice_default_count)
  map.put("universe_dice_face_style_label", Res.string.universe_dice_face_style_label)
  map.put("universe_dice_face_style_numerals", Res.string.universe_dice_face_style_numerals)
  map.put("universe_dice_face_style_skull", Res.string.universe_dice_face_style_skull)
  map.put("universe_dice_modifiers_enabled", Res.string.universe_dice_modifiers_enabled)
  map.put("universe_dice_multi_enabled", Res.string.universe_dice_multi_enabled)
  map.put("universe_dice_section", Res.string.universe_dice_section)
  map.put("universe_dice_section_hint", Res.string.universe_dice_section_hint)
  map.put("universe_dice_total_enabled", Res.string.universe_dice_total_enabled)
  map.put("universe_dice_winning_high", Res.string.universe_dice_winning_high)
  map.put("universe_dice_winning_label", Res.string.universe_dice_winning_label)
  map.put("universe_dice_winning_low", Res.string.universe_dice_winning_low)
  map.put("universe_features_section", Res.string.universe_features_section)
  map.put("universe_list_loading", Res.string.universe_list_loading)
}
